<template>
    <div class="viewport overflow-hidden">
        <div class="headerBg full-width">
            <h1 class="viewport-header">
                <div class="flex absolute watermark">SUMÁR</div>
                Zhrnutie
            </h1>
        </div>
        <div class="container">
            <div class="content full-width">
                <div class="row q-col-gutter-x">
                    <Animation
                        :customAnimation="[{ animate__fadeInLeft: $q.screen.gt.sm }, { animate__fadeInUp: $q.screen.lt.md }]"
                        inView
                        class="flex justify-center col-12 col-md-7"
                    >
                        <q-img
                            src="@/assets/zhrnutie_img-1400w.png"
                            class="image q-mb-xl"
                        />
                    </Animation>

                    <Animation
                        :customAnimation="[{ animate__fadeInRight: $q.screen.gt.sm }, { animate__fadeInUp: $q.screen.lt.md }]"
                        inView
                        class="flex items-center col-12 col-md-5"
                        :class="{
                            'q-pl-xl': $q.screen.gt.sm,
                        }"
                    >
                        <div v-html="content"></div>
                    </Animation>
                </div>
            </div>
        </div>
        <div
            class="headerBg2 full-width"
            ref="login"
        >
            <h1 class="viewport-header">
                <div class="flex absolute watermark">ELENA</div>
                Tak poďme na to
            </h1>
        </div>
        <div
            class="container full-width q-pt-none justify-center"
            style="align-items: center"
        >
            <LoginPanel :white-bg="true" />
        </div>
    </div>
</template>

<script>
import Animation from '@/components/animation.vue';
import LoginPanel from '@/components/loginPanel.vue';

export default {
    name: 'VpZhrnutie',
    components: {
        Animation,
        LoginPanel,
    },
    props: ['content'],
    data() {
        return {};
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
.viewport {
    background-image: url('@/assets/zhrnutie2-1500w.jpg');
    background-repeat: no-repeat;

    background-size: cover;
}
.headerBg {
    z-index: 1;
    .viewport-header {
        margin: 100px 0;
        color: #ffffff;
        padding: 0 15px;
        .watermark {
            background: linear-gradient(333deg, rgba(13, 69, 172, 1) 0%, rgba(34, 70, 136, 1) 67%, rgba(3, 37, 98, 1) 100%);
            color: rgba(255, 255, 255, 0.05);
        }
    }
}

.headerBg2 {
    z-index: 1;
    .viewport-header {
        color: $primary;
    }
}

.container {
    max-width: $breakpoint-md-max;
}

.image {
    max-width: 600px;
}

.login {
    display: flex;
    background: linear-gradient(123.88deg, rgba(255, 255, 255, 0.79) 4.69%, rgba(255, 255, 255, 0.13) 42.71%, rgba(255, 255, 255, 0.28) 100%);
    box-shadow: 0px 0px 80px rgba(0, 0, 0, 0.25);
    align-items: center;
    padding-top: var(--dl-space-space-twounits);
    padding-left: var(--dl-space-space-twounits);
    padding-right: var(--dl-space-space-twounits);
    padding-bottom: var(--dl-space-space-twounits);
    border-color: rgba(255, 255, 255, 0.5);
    border-width: 0px;
    border-radius: 15px;
    flex-direction: column;
    backdrop-filter: blur(7.5px);
    justify-content: flex-start;

    .login_inside {
        flex: 0 0 auto;
        display: flex;
        align-items: flex-start;
        flex-direction: column;
    }

    .loginformhero-text {
        color: $primary;
        font-size: 2em;
        align-self: center;
        margin-bottom: 48px;
        padding: 0 24px;
        line-height: 1;
        text-align: center;
    }

    @media (max-width: $breakpoint-md-max) {
        margin-right: 0;
    }
    @media (max-width: 1200px) {
        margin-right: 0;
    }

    @media (max-width: $breakpoint-sm-max) {
        .loginformhero-text {
            padding: 0;
        }
    }
}
</style>
